<a
  class="legals-footer-link-item inline-block whitespace-nowrap py-3 pr-2 text-center"
  [link]="link"
  [target]="openInNewTab ? '_blank' : '_self'"
  >{{ name }}</a
>
